import { FilmFiltersOptionsDialogComponent } from './film-filters-options-dialog/film-filters-options-dialog.component';
import { BaseComponentService } from 'src/app/services/_app/base-component.service';
import { FilmFiltersOptions } from 'src/app/models/items/film-filters-options.model';
import { FilmDialogComponent } from './film-dialog/film-dialog.component';
import { FilmService } from 'src/app/services/items/film.service';
import { ApiError } from 'src/app/models/api/api-error.model';
import { Component, inject, OnInit } from '@angular/core';
import { Film } from 'src/app/models/items/film.model';

@Component({
  selector: 'app-films',
  templateUrl: './films.component.html',
  styleUrls: ['./films.component.scss'],
})
export class FilmsComponent implements OnInit {
  private _baseComponentService = inject(BaseComponentService);
  private _filmService: FilmService = inject(FilmService);
  public loading: boolean = true;
  public error?: ApiError;

  public films: Film[] = [];
  private _text?: string = undefined;
  private _filtersOptions: FilmFiltersOptions = {
    languages: [],
    subtitles: [],
    categories: [],
  };

  get filtersOptions(): FilmFiltersOptions {
    return this._filtersOptions;
  }

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.loading = true;
    this.error = undefined;
    this._filmService
      .getListing(this._text, this._filtersOptions)
      .subscribe({
        next: (data: any) => {
          this.films = data?.data?.map((json: any) => new Film(json));
        },
        error: (error: any) => {
          this.error = new ApiError(error);
          console.error('Get Films Error:', this.error);
        },
      })
      .add(() => (this.loading = false));
  }

  onText(text?: string) {
    this._text = text;
    this.getData();
  }

  openFiltersDialog() {
    const dialogRef = this._baseComponentService.dialog.open(
      FilmFiltersOptionsDialogComponent,
      {
        maxWidth: '800px',
        minWidth: '800px',
        autoFocus: false,
        restoreFocus: false,
        data: this._filtersOptions,
      }
    );

    dialogRef.afterClosed().subscribe((filtersOptions: FilmFiltersOptions) => {
      this._filtersOptions = filtersOptions;
      this.getData();
    });
  }

  openFilmDialog(): void {
    const dialogRef = this._baseComponentService.dialog.open(
      FilmDialogComponent,
      {
        maxWidth: '800px',
        minWidth: '800px',
        autoFocus: false,
        restoreFocus: false,
      }
    );

    dialogRef.afterClosed().subscribe((refresh: boolean) => {
      if (refresh) this.getData();
    });
  }

  editFilm(index: number): void {
    const dialogRef = this._baseComponentService.dialog.open(
      FilmDialogComponent,
      {
        maxWidth: '800px',
        minWidth: '800px',
        autoFocus: false,
        restoreFocus: false,
        data: { film: this.films[index] },
      }
    );

    dialogRef.afterClosed().subscribe((refresh: boolean) => {
      if (refresh) this.getData();
    });
  }

  deleteFilm(index: number): void {
    this._baseComponentService
      .confirmDeletion({
        destructive: true,
        message: 'Sei sicuro di voler eliminare questo film?',
        details: "(L'operazione non sarà reversibile)",
      })
      .subscribe((dialogResult: boolean) => {
        if (dialogResult === true && this.films?.at(index)?.id) {
          this._filmService.deleteFilm(this.films?.at(index)?.id).subscribe({
            next: () => this.getData(),
            error: (error: unknown) => {
              this._baseComponentService.showErrorDialog({
                error: new ApiError(error),
              });
            },
          });
        }
      });
  }
}
